<template>
  <div :class="classes">
    <pt-page-title :title="detail.name"></pt-page-title>
    <pt-sub-title title="医院信息"></pt-sub-title>
    <template>
      <div :class="$style['pt-branch-company-detail']">
        <table>
          <tr>
            <td>医院名称：</td>
            <td>{{detail.name}}</td>
          </tr>
          <tr>
            <td>分/子公司：</td>
            <td>{{detail.branchName}}</td>
          </tr>
          <tr>
            <td>地区：</td>
            <td>{{detail.address}}</td>
          </tr>
          <tr>
            <td>医院地址：</td>
            <td>{{detail.hospitalAddress?detail.hospitalAddress:'无'}}</td>
          </tr>
          <tr>
            <td>联系人：</td>
            <td>{{detail.contractor?detail.contractor:'无'}}</td>

          </tr>
          <tr>
            <td>手机号：</td>
            <td>{{detail.mobile?detail.mobile:'无'}}</td>

          </tr>
        </table>
      </div>
      <el-button type="primary" @click="goEdit(detail.id)">编辑</el-button>
    </template>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-hospital-detail'

export default {
  name: 'pt-hospital-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    goEdit (id) {
      this.$router.push('/hospital-manage/hospital-form/true/' + id)
    }
  }

}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";

  :global {
    .pt-branch-company-detail {
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }

      .wt-box {
        justify-content: flex-start;
        margin-left: -1rem
      }

      .wt-box__item {
        margin-right: .5rem
      }
    }

  }

  .pt-branch-company-detail {

    padding: 50px 0;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          width: 1rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }

    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

  .title {
    max-width: 300PX;
  }

  .images {
    // display: inline;
    width: 2rem !important;
  }

</style>
